const ROOT = "/";
const SIGNUP = "/signup";
const SIGNUP_V2 = "/signup-v2";
const SIGNUP_RETURN = `${SIGNUP}/return`;
const LOGIN = "/login";
const PASSWORD_RESET = "/password-reset";
const PASSWORD_RESET_RETURN = `${PASSWORD_RESET}/return`;
const PASSWORD_RESET_FORM = `${PASSWORD_RESET}/form`;
const TUNNISTUS_RETURN = "/tunnistus/return";
const SIGNUP_FORM_V2 = `${SIGNUP_V2}/form`;
const SIGNUP_TOO_YOUNG = `${SIGNUP}/too-young`;
const VERIFICATIONS = "/verifications";

export const routes = {
  ROOT,
  LOGIN,
  SIGNUP,
  SIGNUP_V2,
  SIGNUP_RETURN,
  SIGNUP_FORM_V2,
  SIGNUP_TOO_YOUNG,
  TUNNISTUS_RETURN,
  PASSWORD_RESET,
  PASSWORD_RESET_FORM,
  PASSWORD_RESET_RETURN,
  VERIFICATIONS,
};
